import { Heading } from "@components/heading";
import styled from "styled-components";

export const TableHeading = styled(Heading)`
  font-weight: 500;
`;
